import { __awaiter, __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { ClipboardService, ClipboardModule } from 'ngx-clipboard';
import { ToastController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { Clipboard } from '@ionic-native/clipboard/ngx';

let UiCBilletReviewChargingComponent = class UiCBilletReviewChargingComponent {
    constructor(toastCtrl, clipboardService) {
        this.toastCtrl = toastCtrl;
        this.clipboardService = clipboardService;
        this.shareBilletOnPage = new EventEmitter();
        this.printBilletOnPage = new EventEmitter();
        this.dismiss = new EventEmitter();
        /*  this.clipboardWeb = new ClipboardWeb('#copyBtn'); */
        /*  this.clipboardWeb.on('success', () => {
           this.toastCopy();
         }); */
    }
    ngOnInit() {
        /* Dados mockados */
        this.dataRecipient = {
            name: "Lorem ipsum dolor sit amet, consectetu",
            documentDefault: "999.999.999-99",
            description: "Lorem ipsum dolor sit amet, consectetuLorem ipsum dolor sit amet, consectetu"
        };
    }
    copyBilletCode() {
        this.clipboardService.copyFromContent(this.billetCode);
        this.toastCopy();
    }
    shareBillet() {
        this.shareBilletOnPage.emit();
    }
    printBillet() {
        this.printBilletOnPage.emit();
    }
    dismissEvent() {
        this.dismiss.emit();
    }
    toastCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Dados copiados!',
                duration: 2000
            });
            toast.present();
        });
    }
    setValueShow(value) {
        return Number(value.replaceAll('.', '').replace(',', '.'));
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBilletReviewChargingComponent.prototype, "rechargeValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBilletReviewChargingComponent.prototype, "billetCode", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewChargingComponent.prototype, "hasCancelButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewChargingComponent.prototype, "hasShareButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewChargingComponent.prototype, "hasPrintButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBilletReviewChargingComponent.prototype, "dataRecipient", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBilletReviewChargingComponent.prototype, "billetForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBilletReviewChargingComponent.prototype, "typeableLine", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewChargingComponent.prototype, "shareBilletOnPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewChargingComponent.prototype, "printBilletOnPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewChargingComponent.prototype, "dismiss", void 0);
UiCBilletReviewChargingComponent = __decorate([
    Component({
        selector: 'ui-c-billet-review-charging',
        template: "<div class=\"ui-c-billet-review-charging mt-5 d-flex flex-column align-items-center justify-content-around\">\n  <div class=\"ion-text-center\">\n    <h2 class=\"font-weight-bold\">{{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.HEADER.TITLE' | wlpTranslate}}</h2>\n  </div>\n  <div class=\"header-data ion-align-self-start\">\n    <ion-row class=\"\">\n      <ion-col size=\"12\" class=\"ion-padding-vertical\">\n        <ion-label>\n          {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.DUE_DATE' | wlpTranslate}}\n        </ion-label>\n        <br>\n        {{billetForm.dateDue}}\n      </ion-col>\n    </ion-row>\n    <ion-row class=\"\">\n      <ion-col size=\"12\" class=\"ion-padding-vertical\">\n        <ion-label>\n          {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.CPF_CNPJ' | wlpTranslate}}\n        </ion-label>\n        <br>\n        {{billetForm.document}}\n      </ion-col>\n    </ion-row>\n    <ion-row class=\"\">\n      <ion-col size=\"12\" class=\"ion-padding-vertical\">\n        <ion-label>\n          {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.NAME' | wlpTranslate}}\n        </ion-label>\n        <br>\n        {{billetForm.nameComplete}}\n      </ion-col>\n    </ion-row>\n  </div>\n  <p class=\"d-flex align-items-end\">\n    <span class=\"align-self-start\">R$</span>\n    <span class=\"recharge-money\">{{billetForm.billetValue | currency: 'BRL':''}}</span>\n  </p>\n  <div class=\"header-data ion-align-self-start\">\n    <ion-row *ngIf=\"billetForm.descripiton\" class=\"\">\n      <ion-col size=\"12\" class=\"ion-padding-vertical\">\n        <ion-label>\n          {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.DESCRIPTION' | wlpTranslate}}\n        </ion-label>\n        <br>\n        <p class=\"ion-text-wrap\">\n          {{billetForm.descripiton}}\n        </p>\n      </ion-col>\n    </ion-row>\n  </div>\n  <div class=\"d-flex align-items-center\">\n    <ion-button fill=\"clear\" color=\"dark\" id=\"copyBtn\" (click)=\"copyBilletCode()\" data-clipboard-target=\"#copyTarget\">\n      <div class=\"d-flex flex-column\">\n        <div>\n          <ion-icon class=\"icon-size\" [name]=\"'copy-outline'\"></ion-icon>\n        </div>\n        <div>\n          <span class=\"text-capitalize\">{{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.COPY' | wlpTranslate}}</span>\n        </div>\n      </div>\n    </ion-button>\n    <p class=\"d-flex flex-column billet-code-p-tag\" >\n      <span class=\"font-weight-bold\">\n        {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BILLET_CODE' | wlpTranslate}}\n      </span>\n      <span id=\"copyTarget\">\n        {{typeableLine}}\n      </span>\n    </p>\n  </div>\n</div>\n\n<div class=\"group-buttons\">\n  <div class=\"container content-below\">\n    <ion-row>\n      <ion-col size=\"12\" class=\"ion-padding\">\n        <ui-c-button *ngIf=\"hasPrintButton\" class=\"btn-green\" expand=\"block\" (continue)=\"printBillet()\">\n          <span class=\"\">\n            {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.PRINT' | wlpTranslate}}\n          </span>\n        </ui-c-button>\n        <div class=\"mt-1\" *ngIf=\"hasShareButton\">\n          <ui-c-button class=\"blue-button\" expand=\"block\" (continue)=\"shareBillet()\">\n            <span class=\"\">\n              {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.SHARE' | wlpTranslate}}\n            </span>\n          </ui-c-button>\n        </div>\n        <div class=\"mt-1\" *ngIf=\"hasCancelButton\">\n          <ui-c-button class=\"cancel-button\" expand=\"block\" (continue)=\"dismissEvent()\">\n            <span class=\"\">\n              {{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.CANCEL' | wlpTranslate}}\n            </span>\n          </ui-c-button>\n        </div>\n      </ion-col>\n    </ion-row>\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [ToastController,
        ClipboardService])
], UiCBilletReviewChargingComponent);

let UiCBilletReviewChargingModule = class UiCBilletReviewChargingModule {
};
UiCBilletReviewChargingModule = __decorate([
    NgModule({
        declarations: [
            UiCBilletReviewChargingComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiCButtonModule,
            UiBsTranslateModule,
            ClipboardModule
        ],
        providers: [
            Clipboard,
            ClipboardService
        ],
        exports: [
            UiCBilletReviewChargingComponent
        ]
    })
], UiCBilletReviewChargingModule);

export { UiCBilletReviewChargingComponent, UiCBilletReviewChargingModule };
//# sourceMappingURL=wlp-ui-c-billet-review-charging.js.map
